import React, { Component } from 'react';
import { TextBox } from 'devextreme-react';
import i18n from '../../i18n';
import ReeValidate from 'ree-validate';
import vi from 'ree-validate/dist/locale/vi';
import en from 'ree-validate/dist/locale/en';
import PropTypes from 'prop-types';

class NameBox extends Component {
    constructor(props) {
        super(props);

        this.validator = new ReeValidate({
            name: this.props.validatorValue
        });

        if (this.props.currentLanguage === 'vi-VN') {
            this.validator.localize('vi', vi);
        } else {
            this.validator.localize('en', en);
        }

        if (this.props.value) {
            this.validator.validate('name', this.props.value).then(() => {
                this.checkValidate();
            });
        }

        this.valueChanged = this.valueChanged.bind(this);
    }

    valueChanged = (e) => {
        if (e.event !== undefined && e.event !== null) {
            if (e.event.type !== 'dxclick') {
                const { errors } = this.validator;
                const value = e.event.target.value;

                errors.remove(e.event.target.name);
                this.props.updateData({
                    [this.props.field]: value
                });

                this.validator
                    .validate(e.event.target.name, value)
                    .then(() => {
                        this.checkValidate();
                    })
                    .catch(() => { });
            }
        }
    };

    checkValidate() {
        const { field } = this.props;

        const formValidate = !this.validator.errors.has('name');
        this.props.updateData({
            formValidate: { [field]: formValidate }
        });
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.props.value) {
            this.validator.validate('name', nextProps.value).then(() => {
                this.checkValidate();
            });
        }
    }

    render() {
        const { value, i18nLabel, validatorValue, readOnly, errorMes } = this.props;
        return (
            <div className={'selectBatches' + (this.validator.errors.has('name') ? ' has-error' : '')}>
                <div className={'dx-field'}>
                    <div className={'dx-field-label'}>
                        {i18n.t(i18nLabel) + ':'}
                        {!readOnly && validatorValue &&
                            validatorValue.includes('require') && (<span className="color-red"> *</span>)}
                    </div>

                    <div className={'dx-field-value'}>
                        <TextBox
                            className={'multi-language'}
                            name={'name'}
                            value={value}
                            placeholder={i18n.t(i18nLabel)}
                            onValueChanged={this.valueChanged}
                            readOnly={readOnly || false}
                        />

                        {this.validator.errors.has('name') && (
                            <div className="help-block">
                                {errorMes || this.validator.errors
                                    .first('name')
                                    .replace('name', i18n.t(i18nLabel))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

NameBox.propTypes = {
    value: PropTypes.string,
    i18nLabel: PropTypes.string,
    validatorValue: PropTypes.string,
    readOnly: PropTypes.bool,
    updateData: PropTypes.func,
    field: PropTypes.string,
    currentLanguage: PropTypes.string,
    errorMes: PropTypes.string
};

export default NameBox;
